// src/Pages/LoginPage.tsx (or wherever you keep it)

import React, { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../msalConfig";

import axios from "../utils/Security/axiosInstance";
import backgroundImage from "../Assets/23982775.jpg";
import Input from "../Components/input/input";
import config from "../config";
import "../Style/LoginPage.css";

const LoginPage: React.FC = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isMsLoading, setIsMsLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  const { instance } = useMsal();

  const handleInputChange = (field: "username" | "password", value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // ==========================================
  // NORMAL USERNAME/PASSWORD LOGIN
  // ==========================================
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage("");
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${config.apiBaseUrl}/api/auth/login`,
        formData
      );

      const {
        token,
        refreshToken,
        isAdmin,
        superadmin,
        isUser,
        userid,

        position,
        organzation,
        ismanager,
        isemployee,
isForTelebras,
isForPetrobras,
        isForNilesat,

      } = response.data;
      console.log(organzation)

      localStorage.setItem("authToken", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("isAdmin", isAdmin);
      localStorage.setItem("superadmin", superadmin);
      localStorage.setItem("isUser", isUser);
      localStorage.setItem("username", formData.username);
      localStorage.setItem("userid", userid);
      localStorage.setItem("position", position);
      localStorage.setItem("organization", organzation);
      localStorage.setItem("ismanager", ismanager);
      localStorage.setItem("isemployee", isemployee);
 localStorage.setItem("isForTelebras" , isForTelebras);
 localStorage.setItem("isForPetrobras" , isForPetrobras);
      localStorage.setItem("isForNilesat", isForNilesat);

      setSuccessMessage("Login successful!");
      navigate("/home");
    } catch (err: any) {
      console.error("Login error:", err);
      setError(err?.response?.data?.message || "Invalid credentials");
    } finally {
      setIsLoading(false);
    }
  };

  // ==========================================
  // MICROSOFT LOGIN
  // ==========================================
  const handleMicrosoftLogin = async () => {
    setError(null);
    setSuccessMessage("");
    setIsMsLoading(true);

    try { 
      // 1) Login with Microsoft via popup
      const response = await instance.loginPopup(loginRequest);

      // 2) Extract email / preferred username from Microsoft account
      const account = response.account;
      const claims: any = response.idTokenClaims || {};
      const email =
        claims.preferred_username || claims.email || account?.username;

      if (!email) {
        throw new Error("Could not get email from Microsoft account");
      }

      // 3) Call backend to exchange Microsoft identity for YOUR JWT
      const backendResponse = await axios.post(
        `${config.apiBaseUrl}/api/auth/microsoft`,
        { email }
      );

      const {
        token,
        refreshToken,
        isAdmin,
        superadmin,
        isUser,
        userid,
        username,
        position,
        organization,
        ismanager,
        isemployee,
isForTelebras,
isForPetrobras,
        isForNilesat,

      } = backendResponse.data;

      if (!token) {
        throw new Error(
          backendResponse.data?.message ||
            "Microsoft login failed: no token returned"
        );
      }

      localStorage.setItem("authToken", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("isAdmin", isAdmin);
      localStorage.setItem("superadmin", superadmin);
      localStorage.setItem("isUser", isUser);
      localStorage.setItem("username", username);
      localStorage.setItem("userid", userid);
      localStorage.setItem("position", position);
      localStorage.setItem("organization", organization);
      localStorage.setItem("ismanager", ismanager);
      localStorage.setItem("isemployee", isemployee);
 localStorage.setItem("isForTelebras" , isForTelebras);
localStorage.setItem("isForPetrobras" , isForPetrobras);
       localStorage.setItem("isForNilesat", isForNilesat);


      setSuccessMessage("Logged in with Microsoft successfully!");
      navigate("/home");
    } catch (err: any) {
      console.error("Microsoft login error:", err);
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Microsoft login failed";
      setError(msg);
    } finally {
      setIsMsLoading(false);
    }
  };

  return (
    <div
      className="background"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="head">
        <h2>Bcom Dispute Management</h2>
      </div>

      <div className="login-form">
        <h2>Login</h2>

        {(isLoading || isMsLoading) && (
          <div className="loading-message">
            {isLoading ? "Logging in..." : "Signing in with Microsoft..."}
          </div>
        )}

        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}
        {error && <div className="error-message">{error}</div>}

        {/* ==========================
            NORMAL CREDENTIAL LOGIN
           ========================== */}
        {/* <form onSubmit={handleSubmit}>
          <Input
            type="text"
            placeholder="Username"
            value={formData.username}
            onChange={(v) => handleInputChange("username", v)}
            required
          />

          <Input
            type="password"
            placeholder="Password"
            value={formData.password}
            onChange={(v) => handleInputChange("password", v)}
            required
          />

          <button type="submit" disabled={isLoading || isMsLoading}>
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>


        <div className="login-divider">
          <span>OR</span>
        </div> */}

        <button
          type="button"
          className="microsoft-login-button"
          onClick={handleMicrosoftLogin}
          disabled={isMsLoading || isLoading}
        >
          {isMsLoading
            ? "Signing in with Microsoft..."
            : "Login with Microsoft"}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
